import { useFormState } from '@slal/ui/react-hook-form/core';
import { Notice } from '../Notice';

export const ValidationWarning = () => {
    const { errors } = useFormState();
    const messages = Object.keys(errors).map(key => errors[key]?.message || errors[key]?.root?.message);
    return messages?.length && typeof messages[0] === 'string' ? <Notice level="danger">{messages[0]}</Notice> : null;
};
